<template>
  <div class="row poppins h-100">
    <div class="col-12 h-100">
      <b-tabs
        pills
        card
        active-tab-class="px-0"
        content-class="overflow-auto pr-1"
        class="h-100 d-flex flex-column"
      >
        <b-tab
          :title="'Cases' | i18n"
          active
        >
          <Cases :get-cases="getCases" />
        </b-tab>
        <b-tab :title="'Reports' | i18n">
          <Reports
            v-if="hideReports"
            :get-reports="getReports"
            :case-ids="caseIds"
          />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue';
import { ReportsMixin, NotificationMixin } from '../../../../mixins';

import Reports from './components/reports';
import Cases from './components/cases';

export default {
  name: 'Settings',
  components: { 'b-tabs': BTabs, 'b-tab': BTab, Reports, Cases },
  mixins: [ReportsMixin, NotificationMixin],
  data: function () {
    return {
      reports: [],
      cases: [],
      hideReports: false,
    };
  },
  computed: {
    caseIds: function () {
      return this.cases.map((c) => c.id);
    },
  },
  methods: {
    async getReports(filter) {
      try {
        const response = await this.reportsService.getDeletedReports(filter);
        this.reports = response.data;
        return response;
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    async getCases(filter) {
      try {
        this.hideReports = false;
        const response = await this.reportsService.getDeletedCases(filter);
        this.cases = response.data;
        this.hideReports = true;
        return response;
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .card-header {
  background: white;
}
::v-deep .nav-item a {
  margin-right: 10px;
  justify-content: center;
  align-items: center;
  display: flex;
}
</style>
